import { MetadataMap } from "./metadata-map";
import { getEntityPrototypeChain } from "./utils";
const ATTRIBUTES_MAP = new MetadataMap();
export function attribute(options) {
    const opts = options || {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (target, key) => {
        ATTRIBUTES_MAP.setMetadataByType(target.constructor, key, {
            name: key,
            ...opts,
        });
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
export function getAttributeMetadata(target) {
    return getEntityPrototypeChain(target).reduce((soFar, prototype) => Object.assign(soFar, ATTRIBUTES_MAP.getMetadataByType(prototype)), {});
}
